import { render } from "./Gene.vue?vue&type=template&id=33255e3e&scoped=true"
import script from "./Gene.vue?vue&type=script&lang=js"
export * from "./Gene.vue?vue&type=script&lang=js"

import "./Gene.vue?vue&type=style&index=0&id=33255e3e&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc/v1/v1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33255e3e"]])

export default __exports__